/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

import Calendar from './calendar/zh_CN';
import DatePicker from './date-picker/zh_CN';
import Pagination from './pagination/zh_CN';
import TimePicker from './time-picker/zh_CN';

export default {
  locale: 'zh-cn',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  // locales for all comoponents
  global: {
    placeholder: 'è¯·éæ©'
  },
  Table: {
    filterTitle: 'ç­é',
    filterConfirm: 'ç¡®å®',
    filterReset: 'éç½®',
    selectAll: 'å¨éå½é¡µ',
    selectInvert: 'åéå½é¡µ',
    sortTitle: 'æåº'
  },
  Modal: {
    okText: 'ç¡®å®',
    cancelText: 'åæ¶',
    justOkText: 'ç¥éäº'
  },
  Popconfirm: {
    cancelText: 'åæ¶',
    okText: 'ç¡®å®'
  },
  Transfer: {
    searchPlaceholder: 'è¯·è¾å¥æç´¢åå®¹',
    itemUnit: 'é¡¹',
    itemsUnit: 'é¡¹'
  },
  Upload: {
    uploading: 'æä»¶ä¸ä¼ ä¸­',
    removeFile: 'å é¤æä»¶',
    uploadError: 'ä¸ä¼ éè¯¯',
    previewFile: 'é¢è§æä»¶'
  },
  Empty: {
    description: 'ææ æ°æ®'
  }
};
